import { IconButton, Tooltip } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { Link } from 'react-router-dom';

export type EditButtonProps = {
  to: string;
  title: string;
  disabled?: boolean;
};

export function EditButton({ to, disabled, title }: EditButtonProps) {
  if (disabled) {
    return (
      <Tooltip title={title}>
        <span>
          <IconButton disabled={disabled} size='small'>
            <Edit fontSize='small' />
          </IconButton>
        </span>
      </Tooltip>
    );
  }
  return (
    <Tooltip title={title}>
      <Link to={to}>
        <IconButton size='small'>
          <Edit fontSize='small' />
        </IconButton>
      </Link>
    </Tooltip>
  );
}
